import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { PageWrapper } from 'components';
import AdminVideo from '../../video/admin_video.mp4';
import BuyerVideo from '../../video/buyer_video.mp4';
import SellerVideo from '../../video/seller_video.mp4';
import { useSelector } from 'react-redux';

const IntroSectionHolder = styled.section`
  padding: 40px 0;

  .button-primary {
    &.left {
      display: none;
    }

    &.right {
      margin-top: 40px;
    }
  }

  @media only screen and (min-width: 1026px) {
    padding: 112px 40px 126px;

    .button-primary {
      &.left {
        display: block;
      }

      &.right {
        display: none;
      }
    }
  }
`;

const StyledHeading = styled.h1`
  margin: 0 0 10px;
  color: #424141;
  font-weight: 500;
  font-size: 24px;
  text-transform: uppercase;

  @media only screen and (min-width: 1026px) {
    margin: 0 0 23px;
    font-size: 36px;
    line-height: 42px;
  }
`;

const StyledDescription = styled.p`
  margin-bottom: 22px;
  color: #54607d;
  font-size: 14px;
  line-height: 24px;

  span {
    display: block;
  }

  @media only screen and (min-width: 1026px) {
    margin-bottom: 48px;
    font-size: 18px;
  }
`;

const VideoHolder = styled.div`
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);

  video {
    display: block;
  }

  @media only screen and (min-width: 1026px) {
    margin-left: 70px;
  }
`;

const config = {
  admin: {
    title: 'Streamline Auctions with New Admin Tools',
    description:
      'Unveil the potential of your auctions with our latest administrative enhancements! Seamlessly set starting bids and decisive reserve prices to guide successful sales. Engage in efficient negotiations with top bidders through intuitive indicators and direct counter-offers. With these strategic tools, manage your auctions more effectively and watch as your operations become more streamlined and profitable. Upgrade your auction experience today!',
    videoSrc: AdminVideo
  },
  seller: {
    title: 'Maximize Your Sales with New Seller Features',
    description:
      "Welcome to our latest feature update, tailored for sellers to revolutionize your vehicle auction experience! Discover the ease of setting 'Starting Bids' and 'Reserve Prices' in both automatic and manual upload processes, ensuring you kickstart the auction at your preferred price point. Embrace the power of the reserve price to guarantee sales at or above your desired value. Navigate through our intuitive dashboard to track your vehicles' auction statuses in real time, with clear indicators for reserve price met or unmet. Learn how to effectively negotiate post-auction with top buyers or adjust reserve prices for enhanced selling opportunities. These enhancements are designed to give you greater control, flexibility, and potential for higher sales. Transform your auction strategy and achieve better outcomes with these exciting new tools!",
    videoSrc: SellerVideo
  },
  buyer: {
    title: 'Revolutionizing Your Bidding Experience',
    description:
      'Welcome to a transformative bidding journey with our newly enhanced auction features! Dive into our concise video guide and master the art of strategic bidding. Learn how you can swiftly place bids, effortlessly track auction dynamics, and make informed decisions with our innovative bright panel and real-time status updates. Elevate your buying strategy, outbid competitors with precision, and secure your desired vehicles. Embark on a smoother, faster, and more efficient bidding process today!',
    videoSrc: BuyerVideo
  }
};

export const NewFeatures = () => {
  const user = useSelector(state => state.user?.user);
  if (!user) return null;

  const { title, description, videoSrc } = config[user.role];

  return (
    <PageWrapper className={''}>
      <IntroSectionHolder>
        <Grid container>
          <Grid item xs={12} md={5}>
            <StyledHeading>{title}</StyledHeading>
            <StyledDescription>{description}</StyledDescription>
          </Grid>
          <Grid item xs={12} md={7}>
            <VideoHolder>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video controls width="100%">
                <source src={videoSrc} type="video/mp4" />
              </video>
            </VideoHolder>
          </Grid>
        </Grid>
      </IntroSectionHolder>
    </PageWrapper>
  );
};
